import React, { useRef, useState } from 'react'
import { View, ScrollView, Image, Platform } from 'react-native'
import * as Linking from 'expo-linking'
import { StackNavigationProp } from '@react-navigation/stack'

import tw from 'tailwind-rn'
import { useSelector } from 'react-redux'
import styles from './styles'
import { getAssetUrl } from '../../lib/utils'
import {
  HGView,
  HGGroup,
  HGText,
  HGFlatList,
  HGButton,
} from '../../components/HGUI'
import { Markdown } from '../../components/Content'
import { RootStackParamList } from '../../navigators/AppNavigator'
import CrossPlatformImage from '../../components/CrossPlatformImage'

const check = require('../../../assets/img/other/check.png')

const copy1_2 = `## Dringende Meldung an:
- Notarzt
- Polizei 
- Jugendamt`
const copy2 = `## Informieren Sie das Jugendamt!
Nutzen Sie dazu den Meldebogen und wenden Sie sich an das zuständige Jugendamt
              `

type Props = {
  navigation: StackNavigationProp<RootStackParamList>
}

const SuspicionCheckerAcuteDangerChildrenScreen = (props: Props) => {
  const { navigation } = props
  const globals = useSelector((state) => state.globals)
  const [currentStage, setCurrentStage] = useState<string>('0')
  const scrollView = useRef(null)

  // const openModal = (route: string) => {}

  const enterStage = (stage: string) => {
    setCurrentStage(stage)
    scrollView.current.scrollTo({ y: 0, animated: true })
  }

  return (
    <HGView>
      <ScrollView ref={scrollView}>
        <View style={tw('pt-6 px-3')}>
          {/* 0 */}
          {currentStage === '0' && (
            <View>
              <View style={tw('mb-5')}>
                <Markdown>
                  ## Weisen Sie das Kind in die nächstgelegene Klinik ein und
                  informieren Sie diese notwendigerweise vorab telefonisch!
                </Markdown>
              </View>

              <HGGroup>
                <HGText style={styles.questionText}>
                  Sind die Eltern in der Lage das Kind vorzustellen?
                </HGText>
              </HGGroup>

              <View style={styles.actionBox}>
                <HGButton
                  style={styles.buttonHalfWidth}
                  title="Ja"
                  onPress={() => enterStage('1-1')}
                />
                <HGButton
                  style={styles.buttonHalfWidth}
                  type="inverted"
                  title="Nein"
                  onPress={() => enterStage('1-2')}
                />
              </View>
            </View>
          )}

          {/* 1-1 */}
          {currentStage == '1-1' && (
            <View>
              <View style={tw('mb-5')}>
                <Markdown>
                  ## Führen Sie nun den Kontrollanruf in der Klinik durch.
                </Markdown>
              </View>

              <HGGroup>
                <HGText style={styles.questionText}>
                  Ist das Kind in der Klinik angekommen?
                </HGText>
              </HGGroup>

              <View style={styles.actionBox}>
                <HGButton
                  style={styles.buttonHalfWidth}
                  title="Ja"
                  onPress={() => enterStage('3')}
                />
                <HGButton
                  style={styles.buttonHalfWidth}
                  type="inverted"
                  title="Nein"
                  onPress={() => enterStage('1-2')}
                />
              </View>
            </View>
          )}

          {/* 1-2 */}
          {currentStage === '1-2' && (
            <View>
              <View style={tw('mb-5')}>
                <Markdown content={copy1_2} />
              </View>

              <HGFlatList
                scrollEnabled={false}
                data={[
                  {
                    title: 'Meldestellen',
                    description: 'Jugendämter',
                    type: 'link',
                    key: 'chapter-advicecenter',
                    onPress: () =>
                      navigation.push('GenericResource', {
                        resourceId: '38',
                        slug: 'meldestellen',
                        ...(Platform.OS !== 'web' && { name: 'Meldestellen' }),
                      }),
                  },
                ]}
                keyExtractor={(item) => item.key}
              />

              <View style={styles.bottomActionBox}>
                <HGButton
                  title="Nächster Schritt"
                  onPress={() => enterStage('2')}
                />
              </View>
            </View>
          )}

          {/* 2 */}
          {currentStage === '2' && (
            <View>
              <View style={tw('mb-5')}>
                <Markdown content={copy2} />
              </View>

              <HGFlatList
                scrollEnabled={false}
                data={[
                  {
                    title: 'Meldebogen',
                    type: 'download',
                    key: 'chapter-advicecenter',
                    onPress: () =>
                      Linking.openURL(getAssetUrl(globals?.reportingForm)),
                  },
                ]}
                keyExtractor={(item) => item.key}
              />

              <View style={styles.bottomActionBox}>
                <HGButton
                  title="Nächster Schritt"
                  onPress={() => enterStage('3')}
                />
              </View>
            </View>
          )}

          {/* 3 Success */}
          {currentStage === '3' && (
            <View>
              <View style={[styles.successBox, tw('mb-5')]}>
                <View style={tw('mr-3')}>
                  <CrossPlatformImage source={check} style={tw('w-5 h-5')} />
                </View>
                <View style={{ flex: 1, flexWrap: 'wrap' }}>
                  <Markdown>
                    ### Danke für Ihr Engagement im Kinderschutz!
                  </Markdown>
                </View>
              </View>

              <Markdown>
                Vergessen Sie nicht jeden Schritt zu dokumentieren. Den
                Dokumentationsbogen können Sie hier herunterladen:
              </Markdown>

              <HGFlatList
                scrollEnabled={false}
                data={[
                  {
                    title: 'Dokumentationsbogen',
                    type: 'download',
                    key: 'chapter-download1',
                    onPress: () =>
                      Linking.openURL(getAssetUrl(globals?.documentationForm)),
                  },
                ]}
                keyExtractor={(item) => item.key}
              />

              <View style={styles.bottomActionBox}>
                <HGButton
                  title="Zurück zur Dokumentation"
                  onPress={() =>
                    navigation.reset({
                      routes: [{ name: 'Documentation' }],
                    })
                  }
                />
              </View>
            </View>
          )}
        </View>
      </ScrollView>
    </HGView>
  )
}

export default SuspicionCheckerAcuteDangerChildrenScreen
